import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationVaultCardDetails = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
